/**
 * 定时任务调度日志
 * 
 * @author whiteshader
 * @date 2023-02-07
 */

export default {
	'monitor.job.log.title': '定时任务调度日志',
	'monitor.job.log.job_log_id': '任务日志编号',
	'monitor.job.log.job_name': '任务名称',
	'monitor.job.log.job_group': '任务组名',
	'monitor.job.log.invoke_target': '调用方法',
	'monitor.job.log.job_message': '日志信息',
	'monitor.job.log.status': '执行状态',
	'monitor.job.log.exception_info': '异常信息',
	'monitor.job.log.create_time': '创建时间',
};
